import { createContext, useContext, useState, useCallback } from "react";

const TourContext = createContext(null);

export function TourProvider({ children }) {
  const [active, setActive] = useState(false);
  const [step, setStep] = useState(0);

  const startTour = useCallback(() => {
    setStep(0);
    setActive(true);
  }, []);

  const next = useCallback((total) => {
    setStep((s) => {
      if (s >= total - 1) {
        setActive(false);
        localStorage.setItem("tourDone", "1");
        return 0;
      }
      return s + 1;
    });
  }, []);

  const prev = useCallback(() => {
    setStep((s) => Math.max(0, s - 1));
  }, []);

  const end = useCallback(() => {
    setActive(false);
    localStorage.setItem("tourDone", "1");
  }, []);

  return (
    <TourContext.Provider value={{ active, step, startTour, next, prev, end }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  return useContext(TourContext);
}
